export enum REQUEST_METHOD {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  DELETE = 'delete',
}

export enum PAGE {
  PAGE_SIZE_10 = 10,
  PAGE_SIZE_15 = 15,
  PAGE_SIZE_20 = 20,
  PAGE_SIZE_25 = 25,
  PAGE_SIZE_30 = 30,
}

export const DATE_PATTERN = {
  YYYY_MM_DD: 'YYYY/MM/DD',
  YYYY_MM_DD_HH_mm_ss: 'YYYY/MM/DD HH:mm:ss',
  DD_MM_YYYY: 'DD/MM/YYYY',
  YYYY: 'YYYY',
  MM_YYYY: 'MM/YYYY',
  MM_DD: 'MM/DD',
  ISO: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
  YYYYMMDD: 'YYYYMMDD',
  YYYY__MM__DD: 'YYYY-MM-DD',
};

export const NOTIFY_TYPE = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
};

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 100,
  PAGE_SIZE_OPTION: [10, 15, 20, 25, 30],
  DEFAULT_TOTAL_PAGE: 1,
};

export const DEFAULT_LIMIT_SIZE = 100;
export const MONTH = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export enum TYPE_FILE {
  XLS = 'xls',
  XLSX = 'xlsx',
  CSV = 'csv',
  ZIP = 'zip',
  XLSM = 'xlsm',
}

export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

export const SCREEN_NAME = {
  PRODUCT: '製品',
  SHIPPING: '出荷',
  ORDER: '手配',
  DAILY_REPORT: '作業日報',
  HOME: 'Home',
};

type SortOrderDate = 'ascend' | 'descend';

export const SORT_DATE_TYPE: { [key: string]: SortOrderDate } = {
  ASC: 'ascend',
  DESC: 'descend',
};

export const ORDER_STATUS = {
  PARTIAL_DELIVERY: {
    VALUE: 0,
    LABEL: '分納',
    COLOR: '#D77314',
  },
  COMPLETED: {
    VALUE: 1,
    LABEL: '完納',
    COLOR: '#1D7D81',
  },
  CLOSE: {
    VALUE: 2,
    LABEL: 'CLOSE',
    COLOR: '#464F60',
  },
  ALL: {
    VALUE: 3,
    LABEL: '全て',
    COLOR: '',
  },
};

export const RECEIVING_STATUS = {
  UNPAID: {
    VALUE: '1',
    LABEL: '分納',
    COLOR: '#FF5500',
  },
  PAID: {
    VALUE: '2',
    LABEL: '完納',
    COLOR: '#DFE5E9',
  },
};

export const MIMEMAP: { [key: string]: string } = {
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.xlsm': 'application/vnd.ms-excel.sheet.macroEnabled.12',
  '.csv': 'text/csv',
};

export const ORDER_ENUM = {
  MODIFY: {
    TAB: {
      PRODUCT_MASTER: 0,
      ESTIMATED_STOCK: 1,
      SHIPPING_PLAN: 2,
      ORDER_SPECIFICATIONS: 3,
    },
  },
};

export const PLACEHOLDER = {
  SELECT_DATE: '日付を選択',
};

export const COMPLETE = {
  END: '完',
  MINUTES: '分',
};

export const ORDER_NUMBER = {
  '0': '分納',
  '1': '完納',
  '2': 'CLOSE',
};

export const DELIVERY_STATUS = {
  COMPLETE: {
    VALUE: 1,
    LABEL: '完納',
  },
  PARTIAL: {
    VALUE: 0,
    LABEL: '分納',
  },
};

export const PRODUCT_STATUS = {
  SEMI_FINISHED: {
    VALUE: 0,
    LABEL: '仕掛品',
  },
  FINISHED: {
    VALUE: 1,
    LABEL: '完成品',
  },
};

export const PRODUCT_ENUM = {
  MODIFY: {
    TAB: {
      EDIT: 0,
      HISTORY: 1,
    },
  },
};

export const TYPE_PRODUCTION_IMPORT = {
  INVOICE: {
    LABEL: '送り状',
    VALUE: 1,
    KEY: 'invoice',
  },
  DAILY_REPORT: {
    LABEL: '作業日報',
    VALUE: 2,
    KEY: 'daily_work_report',
  },
  SHIPPING: {
    LABEL: 'P包装納入依頼書',
    VALUE: 3,
    KEY: 'shipping',
  },
};

export const PRODUCTION_EXCEPTION = {
  EXCEPTION: {
    ORDER_NUMBER: 99999999,
    DATE: '9999/99/99',
  },
};

export const STATE_ORDER_NUMBER = {
  IDLE: 'IDLE', // 0 -> 0
  FLOATING: 'FLOATING', // Float -> Float
  START_FLOAT: 'START_FLOAT', // 0 -> Float
  STOP_FLOAT: 'STOP_FLOAT', // Float -> 0
};

export const MODAL_TYPE = {
  CONFIRM: 'confirm',
  SHOW_DATA: 'show_data',
};
